import Tooltip from 'bootstrap/js/dist/tooltip';

const clickHandler = (e) => {
  // TODO: Apparently tooltip.js:clickHandler does nothing and can be removed.
  // But first need to find a place with persistent-tooltip

  // this is needed to be able to hide the tooltips on the second tap
  const $this = $(this);
  const tooltip = $this.data('bs.tooltip')?.$tip;
  const seen = $this.data('seen');
  // Tooltips that don't want to be hidden on tap.
  // TODO: Refactor to handle this via directive config instead of
  // an element class name
  const persistentTooltip = $this.hasClass('persistent-tooltip');

  if (persistentTooltip) {
    return;
  }

  // If we're inside a dropdown stop event propagation so that we keep the context
  // and the dropdown doesn't close and we get to see the tooltip.
  if ($this.closest('.dropdown-menu').length) {
    if ($this.hasClass('disabled') || $this.find('a.disabled')) {
      e.stopPropagation();
    }
  }

  if (tooltip?.is(':visible') && seen) {
    $this.tooltip('hide');
  } else {
    if ($('body').hasClass('touch')) {
      $this.tooltip('show');
      // Set to true the seen data attribute
      $(this).data('seen', true);
    }
  }

  // Prevents a tooltip from persisting when clicking a link with a tooltip and hitting the browser's back button
  if (e.data.closeOnClick) {
    $(e.data.container).tooltip('hide');
  }

  // Allows the tooltip to fade out after a set amount of time when triggered by a click
  else if (e.data.life && !e.data.closeOnClick) {
    setTimeout(() => {
      $(e.data.container).tooltip('hide');
    }, e.data.life);

    $(e.data.container).tooltip('toggle');
  }
};
// Support v-tooltip={container: 'self'}
// TODO(v-tooltip): Mounting tooltips to the current element should probably be the default behaviour
// There is barely a point in mounting tooltips to <body>
const getContainer = (container, el) => {
  if (!container) {
    return null;
  }

  return container === 'self' ? $(el) : container;
};
// Vue 3 serializes an attribute bound to `false` as the string "false" (Vue 2
// dropped it entirely), so `:title`/`:data-original-title="<falsy>"` reaches the
// DOM as a literal "false"/"null" and Bootstrap renders a bogus tooltip with that
// text. Strip those serialized falsy values so they read as "no title".
const FALSY_TITLE_VALUES = new Set(['false', 'null', 'undefined']);
const stripFalsyTitle = (el) => {
  ['title', 'data-original-title'].forEach((attr) => {
    if (FALSY_TITLE_VALUES.has(el.getAttribute(attr))) {
      el.removeAttribute(attr);
    }
  });
};
const mountTooltip = (el, options = {}) => {
  stripFalsyTitle(el);
  const defaultOptions = {
    trigger: 'hover',
  };
  const $modal = $(el).closest('.modal');
  const isModal = $modal.length;
  const containerEl = getContainer(options && options.container, el);
  // Mount to the actual element if { container: 'self' }
  const container = containerEl && !isModal ? containerEl : isModal ? $modal.get(0) : 'body'; // TODO(v-tooltip): Almost sure we never need to mount to body
  const tooltipOptions = { ...defaultOptions, ...options, container };

  // Handle custom CSS class for tooltip
  if (options?.customClass) {
    const placement = options.placement || 'top';

    tooltipOptions.template = `
      <div class="tooltip ${placement} ${options.customClass}" role="tooltip">
        <div class="tooltip-arrow"></div>
        <div class="tooltip-inner"></div>
      </div>
    `;
  }

  $(el)
    .tooltip(tooltipOptions)
    .data('seen', false)
    .on('click', { container: el, closeOnClick: tooltipOptions.closeOnClick, life: tooltipOptions.life }, clickHandler)
    .on('show.bs.tooltip', function (e) {
      const $el = $(this);

      // Hide all other tooltips
      $('[aria-describedby^="tooltip"]').not(this).tooltip('hide');

      $('body').addClass('tooltip-open');

      // adding a custom css class to the tip of the tooltip specified via data-tipclass
      if ($el.data('tipclass')) {
        $el.data('bs.tooltip').$tip.addClass($el.data('tipclass'));
      }
    })
    .on('hide.bs.tooltip', function (e) {
      $('body').removeClass('tooltip-open');
    });
};
const destroyTooltip = (el) => {
  $(el).off('click', clickHandler).tooltip('destroy');
};
const tooltipTitle = (value) => (value && typeof value === 'object' ? value.title : undefined);

// Vue 3 directive API
export default {
  mounted(el, binding) {
    if (binding.value !== false) {
      mountTooltip(el, binding.value);
    }
  },
  updated(el, binding) {
    if (!!binding.value && binding.oldValue === false) {
      mountTooltip(el, binding.value);

      return;
    }

    if (!!binding.oldValue && binding.value === false) {
      destroyTooltip(el);

      return;
    }

    const title = tooltipTitle(binding.value);

    // In place, not a remount: a remount closes a tooltip the user is hovering.
    if (title && title !== tooltipTitle(binding.oldValue)) {
      Tooltip.getInstance(el)?.setContent({ '.tooltip-inner': title });
    }
  },
  unmounted(el) {
    if ($(el).data('bs.tooltip')) {
      destroyTooltip(el);
    }
  },
};
